import { FC, useEffect, useState } from 'react';
import { Alert, GlobalStyles, Link } from '@mui/material';

const getActiveLanguage = (): string => {
  const match = document.cookie.match(/googtrans=\/en\/([^;]+)/);
  return match ? match[1] : '';
};

export const useIsTranslated = (): boolean => {
  const [isTranslated, setIsTranslated] = useState(false);

  useEffect(() => {
    setIsTranslated(Boolean(getActiveLanguage()));
  }, []);

  return isTranslated;
};

const TranslationBanner: FC = () => {
  const isTranslated = useIsTranslated();

  if (!isTranslated) {
    return null;
  }

  return (
    <>
      <GlobalStyles
        styles={{
          '.goog-te-banner-frame, .skiptranslate iframe.skiptranslate': {
            display: 'none !important',
          },
          body: {
            top: '0 !important',
          },
          '.goog-te-spinner-pos': {
            display: 'none !important',
          },
        }}
      />
      <Alert
        severity="info"
        sx={{
          borderRadius: 0,
          py: 0.5,
          '& .MuiAlert-message': {
            width: '100%',
            textAlign: 'center',
            fontSize: '0.75rem',
          },
        }}
      >
        This page has been automatically translated by{' '}
        <Link
          href="https://translate.google.com"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          Google Translate
        </Link>
        . Translations are machine-generated and may contain errors.
      </Alert>
    </>
  );
};

export default TranslationBanner;
